import "@/plugins/bridge.js";
import { wxshareInit } from "@/plugins/wechatSDK.js";

export default function useShare(item) {
  // sessionStorage.setItem("categoryId", item.id);
  // sessionStorage.setItem("category", item.name);
  let shareUrl =
    "https://zsrbapp.zsnews.cn/mobile/channel/#/?categoryId=" + item.id;
  let shareTitle = "中山+新闻客户端 " + item.name + "频道";
  // 曝光元素
  window.TrackKit.umengAdapter.setExposure({
    category: "ChannelShare",
    title: shareTitle, // 新闻标题
  });
  let shareDesc = " ";

  if (item.id == 114) {
    shareDesc = "发布疫情防控权威信息，提供应急求助服务，助力中山战疫";
  } else if (item.id == 110) {
    shareDesc = "全天候传递大美古镇资讯 深度解析中国灯都发展变化";
  } else if (item.id == 136) {
    shareDesc = "讲好三乡故事，推动高质量发展";
  } else if (item.id == 132) {
    shareDesc = "湾区精品 智美东凤";
  }

  let shareImg = "https://zsrbapp.zsnews.cn" + require("../assets/zsplus.jpg");
  const userAgentString = navigator.userAgent.toLowerCase();
  if (userAgentString.indexOf("zsrbapp") >= 0) {
    window.ZsrbApp.call("shareInfo", {
      title: shareTitle,
      img: shareImg,
      desc: shareDesc,
      url: shareUrl,
    });
  } else if (userAgentString.indexOf("micromessenger") >= 0) {
    wxshareInit({
      title: shareTitle,
      imgUrl: shareImg,
      description: shareDesc,
      url: shareUrl,
      successMethod: "",
    });
  }
}
